import { ReactNode } from 'react';

const circular = () => {
  const seen = new WeakSet();
  return (key: any, value: any) => {
    if (key.startsWith('_')) return; // Don't compare React's internal props.
    if (typeof value === 'object' && value !== null) {
      if (seen.has(value)) return;
      seen.add(value);
    }
    return value;
  };
};

export const isComponentsEqual = (a: ReactNode, b: ReactNode) => {
  const aStr = JSON.stringify(a, circular());
  const bStr = JSON.stringify(b, circular());

  return aStr === bStr;
};
